<template>
	<section class="page">
				<div class="content-box">
					<div class="operator" v-loading="loadings.filter">
						<div class="operator-col">
							<hispickup v-model="filterHisDate"></hispickup>
						</div>
						<div class="operator-col">
							<enum-filter
								size="mini"
								v-model="filterStatus.index"
								clearable
								data-model-name="Order"
								field="status"
							></enum-filter>
						</div>
						<div class="operator-col d-flex">
							<customer-input
								:params="{allowCreate: false,placeholder:'客户'}"
								v-model="filterCustomer"
							></customer-input>
							<div>&nbsp;&nbsp;/&nbsp;&nbsp; </div>
							<customer-input
								:params="{allowCreate: false,placeholder:'代理',type:'Agent'}"
								v-model="filterCustomer"
							></customer-input>
						</div>
						<div class="operator-col">
							<admin-input
								:params="{allowCreate: false, notUseMeAsDefault:true,placeholder:'销售',kvFilter:adminFilter}"
								v-model="filterSaler"
							></admin-input>
						</div>
						<div class="operator-col">
							<product-input :params="{allowCreate: false,placeholder:'SPU 名/码'}" v-model="filterProducts"></product-input>
						</div>
						<div class="operator-col">
							<el-input
								size="mini"
								v-model="filterTableSearch"
								placeholder="单号"
								suffix-icon="el-icon-search"
							></el-input>
						</div>
					</div>
					<sum-table
						ref="sumTable"
						:data-model="editorDataModel"
						:search-filter="filterTableSearch"
						:kv-filter="kvFilter"
						:date-filter="filterHisDate"
						:fields="sumFields"
						list-url="reserve/sums"
					></sum-table>
					<curd-table
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						@doedit="handleEdit($event)"
						:has-delete="false"
						:date-filter="filterHisDate"
						:search-filter="filterTableSearch"
						:kv-filter="kvFilter"
						:show-summary="true"
						list-url="reserve/order_list"
					>
<!--						<template slot="expandShow" slot-scope="scope">-->
<!--							<div class="row">-->
<!--								<div class="col-md-6">-->
<!--									<h5>地址</h5>-->
<!--									<p v-for="(aitem,aindex) in scope.row.address" :key="aindex">{{aindex}}: {{aitem}}</p>-->
<!--								</div>-->
<!--								<div class="col-md-6">-->
<!--									<h5>时间</h5>-->
<!--									<p>开单 {{scope.row.created_at | moment("YYYY-MM-DD HH:mm")}}</p>-->
<!--									<p v-if="scope.row.payed_at">支付 {{scope.row.payed_at | moment("YYYY-MM-DD HH:mm")}}</p>-->
<!--									<p v-if="scope.row.verify_at">确认订单 {{scope.row.verify_at | moment("YYYY-MM-DD HH:mm")}}</p>-->
<!--									<p v-if="scope.row.send_at">发货 {{scope.row.send_at | moment("YYYY-MM-DD HH:mm")}}</p>-->
<!--								</div>-->
<!--								<div class="col-md-6">-->
<!--									<h5>备注</h5>-->
<!--									<p>{{scope.row.desc}}</p>-->
<!--								</div>-->
<!--								<div class="col-md-6">-->
<!--									<h5>单据/截图</h5>-->
<!--									<p>-->
<!--										<img :src="scope.row.primary_img" class="img-fluid order-img" />-->
<!--									</p>-->
<!--								</div>-->
<!--							</div>-->
<!--							<table class="table table-bordered">-->
<!--								<thead>-->
<!--									<tr>-->
<!--										<th-->
<!--											v-for="(key,index) in itemTableFields"-->
<!--											:key="index"-->
<!--										>{{dataModels.Order_item[key.name].show_name}}</th>-->
<!--									</tr>-->
<!--								</thead>-->
<!--								<tbody>-->
<!--									<tr v-for="tx_item in scope.row.order_items" :key="tx_item._id">-->
<!--										<td v-for="(key,index) in itemTableFields" :key="index">-->
<!--											<field-show-->
<!--												:field-info="dataModels.Order_item[key.name]"-->
<!--												:value="tx_item[key.name]"-->
<!--												:field-key="key"-->
<!--											></field-show>-->
<!--										</td>-->
<!--									</tr>-->
<!--								</tbody>-->
<!--							</table>-->
<!--						</template>-->
						<template slot="listOp" slot-scope="scope">
							<el-button size="mini" type="text" @click="goInfo(scope.row._id)">详情</el-button>
							<el-button
								size="mini"
								type="text"
								@click="doHasPayed(scope.row._id)"
								v-if="!scope.row.has_payed && scope.row.status.index!=0"
							>已收款</el-button>
						</template>
					</curd-table>
				</div>
		<brief-editor
			:show.sync="briefEditorVisible"
			:record-id="briefEditorId"
			@change="refreshTable('listTable')"
			v-if="briefEditorVisible"
		></brief-editor>
		<pay-editor
			:show.sync="payEditorVisible"
			:record-id="payEditorId"
			@change="refreshTable('listTable')"
			v-if="payEditorVisible"
		></pay-editor>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import FilterSaler from "@/mixins/Filter/FilterSaler.js";
import FilterCustomer from "@/mixins/Filter/FilterCustomer.js";
import FilterStatus from "@/mixins/Filter/FilterStatus.js";
import FilterProducts from "@/mixins/Filter/FilterProducts.js";
import FilterIsFrontOrder from "@/mixins/Filter/FilterIsFrontOrder.js";

import OrderOp from "@/mixinsApp/OrderOp.js";
import TabPage from "@/mixins/TabPage.js";
import TxOp from "@/mixinsApp/TxOp";
import LoadDM from "@/mixins/LoadDM.js";
import { mapState, mapGetters, mapMutations } from "vuex";
import { RenderOrderLists, RenderSaler, RenderWarehouse} from "@/mixinsApp/Render.js";

export default {
	mixins: [
		CurdPage,
		Filters,
		FilterSaler,
		FilterCustomer,
		FilterStatus,
		FilterProducts,
		FilterIsFrontOrder,
		OrderOp,
		TabPage,
		LoadDM,
		TxOp
	],
	config: {
		adminFilter: [
			{
				k: "is_leave",
				t: "bool",
				v: 0,
			},
			{
				k: "is_saler",
				t: "bool",
				v: 1,
			},
		],
	},
	data() {
		return {
			dataModelNames: ["Order", "Order_item"],
			editorDataModel: "Order",
			tableFields: [
				{
					name: "show_id",
					sortable: "custom",
					isBold: true,
					needThumb: "primary_img",
				},
				{
					name: "customer",
					sortable: "custom",
					width: "90px",
				},
				{
					name: "express_type",
					render: info => {
						return "[" + info.express_type.name + "] " + info.address.name;
					},
					width: "160px",
				},
				{
					name: "saler",
					render: RenderSaler,
				},
				{
					name: "name",
					width: "350px",
					params: {
						multiHidden: true,
					},
					render: RenderOrderLists,
				},

				{
					name: "total_price",
					sortable: "custom",
					isTag: true,
					params: {
						isRight: true,
						prefix: this.$root.currencyCode,
					},
				},
				{
					name: "created_at",
					sortable: "custom",
				},
				{
					name: "payed_at",
					sortable: "custom",
				},
				{
					name: "verify_at",
					sortable: "custom",
				},
				{
					name: "send_at",
					sortable: "custom",
				},
				{
					name: "status",
					sortable: "custom",
				},
			],
		};
	},
	computed: {
		...mapState(["userPrivilegeMapping"]),
	}
};
</script>
